var _g, _polygon, _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _polygon2, _path4, _rect8, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOdp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    enableBackground: "new 0 0 96 96",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TEMPLATE",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D0D0D0",
    d: "M96,0v96H0V0H96 M97-1h-1H0h-1v1v96v1h1h96h1v-1V0V-1L97-1z"
  })), /*#__PURE__*/React.createElement("g", {
    display: "inline",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF3A6D",
    d: "M90,6v84H6V6H90 M96,0H0v96h96V0L96,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "ICONS"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "88,76 8,76 8,20 70,20 88,38 88,40  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D14C32",
    d: "M60,29.1111c9.3275,0,16.8889,7.5614,16.8889,16.8889H60V29.1111z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    d: "M77,48c0,10.4934-8.5066,19-19,19s-19-8.5066-19-19s8.5066-19,19-19v19H77z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#949494",
    d: "M70.001,18H68H6v60h84V40v-2L70.001,18z M70,21l17,17H70V21z M88,76H8V20h60v20h20V76z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 65,
    fill: "#C8C8C8",
    width: 18,
    height: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 59,
    fill: "#C8C8C8",
    width: 18,
    height: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 53,
    fill: "#C8C8C8",
    width: 18,
    height: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 47,
    fill: "#C8C8C8",
    width: 18,
    height: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 41,
    fill: "#C8C8C8",
    width: 18,
    height: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 35,
    fill: "#C8C8C8",
    width: 18,
    height: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 29,
    fill: "#C8C8C8",
    width: 18,
    height: 2
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "70,21 87,38 70,38  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 6,
    y1: 48,
    x2: 90,
    y2: 48
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2264,
    style: {
      stopColor: "#FCFCFC",
      stopOpacity: 0.0226
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3626,
    style: {
      stopColor: "#F4F4F4",
      stopOpacity: 0.0363
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    style: {
      stopColor: "#E6E6E6",
      stopOpacity: 0.0475
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5744,
    style: {
      stopColor: "#D1D1D1",
      stopOpacity: 0.0574
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6652,
    style: {
      stopColor: "#B7B7B7",
      stopOpacity: 0.0665
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7498,
    style: {
      stopColor: "#979797",
      stopOpacity: 0.075
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8297,
    style: {
      stopColor: "#707070",
      stopOpacity: 0.083
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9057,
    style: {
      stopColor: "#444444",
      stopOpacity: 0.0906
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9761,
    style: {
      stopColor: "#121212",
      stopOpacity: 0.0976
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M68,18H6v60h84V40v-2L70.001,18H68z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 78,
    y1: 45.8125,
    x2: 78,
    y2: 40.175
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#828282",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2812,
    style: {
      stopColor: "#7F7F7F",
      stopOpacity: 0.0281
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4503,
    style: {
      stopColor: "#777777",
      stopOpacity: 0.045
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5899,
    style: {
      stopColor: "#696969",
      stopOpacity: 0.059
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7133,
    style: {
      stopColor: "#545454",
      stopOpacity: 0.0713
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#3A3A3A",
      stopOpacity: 0.0826
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9294,
    style: {
      stopColor: "#1A1A1A",
      stopOpacity: 0.0929
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 40,
    fill: "url(#SVGID_2_)",
    width: 20,
    height: 6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.5916,
    y1: 37.4084,
    x2: 78.4713,
    y2: 26.5287
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8537,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2134
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.25
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M68,18H24v2h44v20h20v38h2V40v-2L70.001,18H68z M70,38V21l17,17H70z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdp);
export default __webpack_public_path__ + "static/media/odp.f134c4ca5287f598251a2b3d88e0cdd9.svg";
export { ForwardRef as ReactComponent };